import { render, staticRenderFns } from "./OptionEditDocumentsTab.vue?vue&type=template&id=cec731b0"
import script from "./OptionEditDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditDocumentsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports